export enum IsSeen {
  notSeen = 0,
  seen = 1,
}
